import React from 'react';
import { Award } from 'lucide-react';

const certifications = [
  { 
    name: 'Google Premier Partner',
    logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/745jkn1k_Top-Google-Premium-Partner-Agencies-in-India.png'
  },
  { 
    name: 'HubSpot Certified Partner',
    logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/q0yltzig_Hubspot%20certified%20partner%20logo.png'
  },
  { 
    name: 'Meta Business Partner',
    logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/7nqcbucr_Meta%20business%20partner%20logo.webp'
  },
  { 
    name: 'Microsoft Select Partner',
    logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/62lw88em_Microsoft%20select%20partner%20logo.jpeg'
  }
];

const Certifications = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center space-x-2 mb-4">
            <Award className="w-6 h-6 text-blue-600" />
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Certified <span className="text-blue-600">Partners</span>
            </h2>
          </div>
          <p className="text-gray-600">Trusted by leading technology platforms</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center p-6 bg-white rounded-xl border-2 border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="w-full h-24 flex items-center justify-center mb-3">
                <img
                  src={cert.logo}
                  alt={cert.name}
                  className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 italic">
            Partner certification badges displayed represent our commitment to industry-leading platforms
          </p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
